import { useTranslation } from "react-i18next";
import { FormAutocomplete, Input, RowInfo } from "../common";
import { GrantsModal, MessagesModal, QualifyModal } from "./modals";
import { useDecision } from '@optimizely/react-sdk'
import { useMemo } from 'react'

const TypeSection = ({ useQuery }) => {
  const { t } = useTranslation();
  const [decisionRewardPoints] = useDecision('reward-points');
  const [decisionRewardFirstJoin] = useDecision('reward-first-join');
  const qualifyOptions = [
    ...Array.from(Array(50).keys()).map(i => ({
        id: i + 1,
        name: String(i + 1),
    })),
    ...[100,200,300,500,1000].map(i => ({
        id: i,
        name: String(i),
    }))
  ]
  const shouldShowNewOptions = useMemo(() => decisionRewardPoints?.enabled || decisionRewardFirstJoin?.enabled, [
    decisionRewardPoints?.enabled,
    decisionRewardFirstJoin?.enabled,
  ])

  return (
    <>
      <RowInfo help={<GrantsModal />}>
        <FormAutocomplete
            help={t("Choose how many players should receive the award.")}
            label={t("Grant to")}
            name="first"
            useQuery={useQuery}
            defaultText={t('unlimited')}
            options={[
            { id: 0, name: t('Unlimited') },
            { id: 1, name: '1' },
            { id: 2, name: '2' },
            { id: 3, name: '3' },
            { id: 4, name: '4' },
            { id: 5, name: '5' },
            { id: 6, name: '6' },
            { id: 7, name: '7' },
            { id: 8, name: '8' },
            { id: 9, name: '9' },
            { id: 10, name: '10' },
            { id: 11, name: '11' },
            { id: 12, name: '12' },
            { id: 13, name: '13' },
            { id: 14, name: '14' },
            { id: 15, name: '15' },
            { id: 16, name: '16' },
            { id: 17, name: '17' },
            { id: 18, name: '18' },
            { id: 19, name: '19' },
            { id: 20, name: '20' },
            { id: 50, name: '50' },
            { id: 99, name: '99' },
            { id: 200, name: '200' },
            { id: 300, name: '300' },
            { id: 400, name: '400' },
            { id: 500, name: '500' }
            ]}
            size="small"
            creatable
        />
      </RowInfo>
      <RowInfo help={<QualifyModal />}>
        <FormAutocomplete
            help={t("The requirements for the award.")}
            label={t("Qualify with")}
            name="trig"
            useQuery={useQuery}
            options={shouldShowNewOptions ? qualifyOptions : [
            { id: 1, name: '1' },
            { id: 2, name: '2' },
            { id: 3, name: '3' },
            { id: 4, name: '4' },
            { id: 5, name: '5' },
            { id: 6, name: '6' },
            { id: 7, name: '7' },
            { id: 8, name: '8' },
            { id: 9, name: '9' },
            { id: 10, name: '10' },
            { id: 11, name: '11' },
            { id: 12, name: '12' },
            { id: 13, name: '13' },
            { id: 14, name: '14' },
            { id: 15, name: '15' },
            { id: 16, name: '16' },
            { id: 17, name: '17' },
            { id: 18, name: '18' },
            { id: 19, name: '19' },
            { id: 20, name: '20' },
            { id: 50, name: '50' },
            { id: 99, name: '99' },
            { id: 200, name: '200' },
            { id: 300, name: '300' },
            { id: 400, name: '400' },
            { id: 500, name: '500' }
            ]}
            size="small"
            creatable
        />
          <FormAutocomplete
            help={t("The requirements for the award.")}
            name="style"
            useQuery={useQuery}
            options={[
                { id: 12, name: t('Background + Photo') },
                ...decisionRewardFirstJoin?.enabled ? [{ id: 15, name: t('First Game Join') }] : [],
                { id: 9, name: t('Multiple Choice') },
                { id: 3, name: t('Photo') },
                ...decisionRewardPoints?.enabled ? [{ id: 2, name: t('Points') }] : [],
                { id: 7, name: t('QR Code') },
                { id: 14, name: t('Split Path') },
                { id: 5, name: t('Sticker Photo') },
                { id: 1, name: t('Submissions') },
                { id: 6, name: t('Text') },
                { id: 8, name: t('Trivia') },
                { id: 4, name: t('Video') },
            ]}
            size="small"
        />
      </RowInfo>
      <RowInfo help={<MessagesModal />}>
        <Input
            help={t("Add a special note when the award is made.")}
            label={t("When awarded, send them this message")}
            name="push"
            useQuery={useQuery}
          />
      </RowInfo>
    </>
  );
};

export default TypeSection;
